import { companyDatas } from "../Content";
import { requisitos } from "../Content";
import {
  personals,
  rights,
  documents,
  advances,
  kycs,
  contacts,
} from "../ContentContractV2";

export function TermsV2() {
  return (
    <>
      <div className="bg-purpleLight relative sm:px-6 lg:px-8">
        <div className="bg-white max-w-3xl mx-auto px-4 pb-6">
          <div className=" text-lg pt-6 max-w-prose mx-auto">
            <h1>
              <span className="mt-2 block text-xl text-center font-bold sm:text-4xl">
                GRUPO EMPRESARIAL ANAV S.A.S. - Galilea
              </span>
            </h1>

            <div className="text-sm lg:text-xl">
              <div className="pt-4 lg:pt-8">
                <span className="block">
                  Estos términos y condiciones, junto con la normativa
                  aplicable, regula la relación jurídica y comercial entre GRUPO
                  EMPRESARIAL ANAV S.A.S., (en adelante “Galilea”) y las
                  personas naturales que solicitan algún producto o servicio (en
                  adelante “Usuarios”) ofrecido a través de la página web
                  https://www.galilea.co{" "}
                </span>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block">
                  El presente documento hace parte integral de los Productos de
                  Crédito ofertados por Galilea. El Usuario manifiesta
                  expresamente que ha leído y está de acuerdo con el contenido
                  de los mismos y por parte de Galilea se cuenta con la
                  aceptación expresa por parte del mismo.
                </span>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">1. Acerca de Galilea.</span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea es una empresa Fintech (proviene de la conjugación
                    de los vocablos ingleses de “Financial & Technology”) que
                    tiene como misión revolucionar el sistema financiero
                    tradicional colombiano, buscando democratizar el acceso a
                    sus servicios y productos de manera ágil y rápida,
                    permitiendo la inclusión financiera a través de la
                    innovación en nuevas tecnologías.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {companyDatas.map((companyData) => (
                    <ul role="list" className="marker:text-purple list-disc">
                      <div key={companyData} className="pl-6 grid grid-cols-5">
                        <div className="col-span-2">
                          <li>{companyData.title}</li>
                        </div>
                        <div className="col-span-3">
                          <span>{companyData.value}</span>
                        </div>
                      </div>
                    </ul>
                  ))}
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">2. Producto. </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea a través de su página web https://www.galilea.co
                    dispone a favor del titular un crédito de bajo monto. Este
                    crédito es informado de manera completa, veraz,
                    transparente, oportuna, verificable, comprensible, precisa e
                    idónea en cada una de las pestañas disponibles en la página
                    web con las cuales el Usuario puede interactuar. Así mismo,
                    el Usuario puede interactuar con el Calculador de crédito
                    por medio del cual puede escoger el monto y elegir la fecha
                    de pago del crédito. El Calculador del crédito no es una
                    oferta de carácter comercial, simplemente corresponde a una
                    forma adicional que dispone Galilea para que el Usuario
                    conozca gráficamente la información del crédito solicitado.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea pone a disposición de los Usuarios un producto de
                    crédito en el que el Usuario puede escoger el monto desde
                    Doscientos mil pesos colombianos (COP$200.000) hasta Un
                    millón Quinientos mil de pesos colombianos (COP$1.500.000).
                    El Usuario también puede escoger la fecha de pago, que por
                    regla general coincide con un periodo de 8 a 40 días.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea a través del Calculador del crédito le informa al
                    Usuario el monto solicitado, la fecha de pago, los intereses
                    corrientes en términos de Efectivo Anual, el Costo opcional
                    de Firma Electrónica y descuento en caso tal que aplique.
                    Esta información el Usuario la puede consultar en todo el
                    proceso de solicitud del crédito y realizar las
                    modificaciones necesarias y pertinentes.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Una vez Galilea recibe la solicitud del monto y plazo,
                    realiza las validaciones de la información proporcionada por
                    el Usuario, esta validación la puede realizar con terceros
                    aliados tipo Buró de crédito, registraduría, entidades
                    bancarias y determina de acuerdo al perfil de riesgo el
                    monto del crédito. El monto de crédito es informado y
                    aceptado por el Usuario.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario tiene la obligación previo al desembolso del
                    crédito de firmar los documentos que lo vinculan legal y
                    contractualmente con Galilea. El Usuario puede realizar la
                    firma a través de medios electrónicos (Firma Electrónica) o
                    de manera física incorporando en los documentos impresos su
                    rúbrica, si el Usuario decide optar por la firma física,
                    deberá notarizar todos los documentos del crédito, este
                    proceso es informado más adelante.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Una vez el Usuario realiza la firma de los documentos del
                    crédito, Galilea procede a iniciar el trámite de desembolso
                    del crédito, el cual de acuerdo a nuestra promesa de valor
                    corresponde a menos de 1 día hábil posterior a la firma de
                    los documentos del crédito. El desembolso puede verse
                    afectado por razones externas a Galilea, correspondiente a
                    la creación e inscripción de la cuenta bancaria, ciclos ACH
                    o error en los datos proporcionados por el Usuario.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea no realiza captación de dineros del público o
                    actividades consideradas privativas del sistema financiero.
                    Razón por la cual, puede presentar casos de iliquidez que
                    imposibiliten desembolsar los recursos al Usuario. Galilea
                    se reserva el derecho de cancelar o no desembolsar el
                    crédito por cualquier razón que considere pertinente sin
                    necesidad de notificar previamente al Usuario. Galilea no
                    utiliza intermediarios ni requiere el pago por anticipado de
                    dineros para la solicitud del crédito, la solicitud del
                    crédito y aprobación es 100% digital y el único proceso que
                    puede ser suplido de manera física por parte del Usuario
                    corresponde a la firma física del crédito.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea realiza el desembolso del crédito única y
                    exclusivamente en la cuenta bancaria del Usuario, Galilea en
                    ningún caso y bajo ninguna circunstancia realiza el
                    desembolso del crédito en cuentas de terceras personas.
                    Galilea desembolsa el valor total del monto solicitado por
                    el Usuario, Galilea no retiene o descuenta del monto a
                    desembolsar ningún costo opcional u obligatorio que deba
                    asumir el Usuario.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  3. Requisitos para acceder al Crédito.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Para acceder al producto ofertado por Galilea descrito en el
                    numeral 2 del presente documento, el Usuario debe reunir los
                    siguientes requisitos:{" "}
                  </span>
                </div>
                {requisitos.map((requisito) => (
                  <div key={requisito} className="pt-4 lg:pt-8">
                    <span className="block">{requisito} </span>
                  </div>
                ))}
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea realiza la validación y verificación de cada uno de
                    estos requisitos. El Usuario es el único responsable por la
                    exactitud de la información proporcionada, en caso tal que
                    Galilea determine que existe inexactitud, error o
                    información falsa en el proceso de solicitud y aprobación
                    del crédito procederá a rechazar de plano la solicitud del
                    crédito, sin que por este hecho se genere algún tipo de
                    sanción o penalidad a Galilea. Galilea podrá a su arbitrio
                    bloquear, reportar ante autoridades judiciales o
                    administrativas cualquier Usuario o situación de alerta
                    referente a la posible comisión de delitos.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  4. Tiempos de desembolso.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea realizará el desembolso del crédito una vez se haya
                    realizado la suscripción por parte del Usuario de los
                    documentos del crédito. Galilea verifica con el banco la
                    titularidad de la cuenta bancaria proporcionada por el
                    Usuario. El crédito se desembolsará en los tiempos y
                    condiciones indicados en el numeral 2 del presente
                    documento. El crédito se desembolsará por medio de{" "}
                    <span className="italic">Automated Clearing House</span>{" "}
                    (ACH por sus siglas en inglés), es por esto que al ser un
                    tercero, Galilea se vincula a sus términos y condiciones,
                    así mismo a las restricciones de horario. Este proceso puede
                    tardar hasta 1 día hábil siguiente a la aceptación del
                    contrato.{" "}
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Las solicitudes iniciadas el fin de semana se gestionan a
                    partir del primer día hábil siguiente. Si la cuenta bancaria
                    no es válida, el banco nos notificará previamente dentro del
                    siguiente día hábil.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea se reserva el derecho de solicitar documentos que
                    sean necesarios para corroborar información, aún después de
                    aprobado el crédito y en general, a negar o retener el
                    desembolso en caso de identificar alguna actividad
                    sospechosa antes, durante y después de aprobado y firmado
                    documentos del crédito.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En caso de iliquidez de capital para desembolsar, Galilea
                    podrá cancelar a su arbitrio los créditos pendientes de
                    desembolso, sin requerir informar previamente al Usuario sin
                    que con esto se genere sanción o penalización para Galilea.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  5. Derecho a pago anticipado.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario está facultado y tiene derecho a efectuar pagos
                    anticipados de las cuotas o saldos en forma total o parcial.
                    En caso que el Usuario decida efectuar pagos anticipados
                    totales o parciales deberá pagar los intereses y los cargos
                    opcionales en proporción con el periodo de realización del
                    pago.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los pagos anticipados que realice el Usuario serán abonados
                    de la siguiente forma:
                  </span>
                </div>
                {advances.map((advance) => (
                  <div key={advance} className="pt-4 lg:pt-8">
                    <span className="block">{advance}</span>
                  </div>
                ))}
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea no exigirá intereses no causados, ni sanciones
                    económicas por el pago anticipado.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">6. Medios de pago. </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario podrá utilizar cualquier plataforma especializada
                    en recaudos, pagos y giros a nivel nacional, siempre que
                    Galilea tenga convenio con dichas entidades. El Usuario
                    tiene el deber de diligencia de conocer los canales
                    autorizados por Galilea para efectuar el pago de su crédito,
                    es por lo anterior, que el Usuario debe ingresar a su cuenta
                    Galilea a través de un clic en “pagar mi cuota”, ingresa el
                    número de documento, validar el{" "}
                    <span className="font-bold italic">reCATCHA</span> y recibe
                    el código de verificación a través de WhatsApp o Email, una
                    vez ingresa, el Usuario debe elegir alguno de nuestros
                    canales físicos o electrónicos para efectuar el pago de su
                    cuota o crédito.{" "}
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario para quedar a paz y salvo con su obligación debe
                    efectuar el pago a través del procedimiento indicado
                    anteriormente. Galilea no se hace responsable si el Usuario
                    efectúa el pago en una cuenta o convenio diferente a los
                    informados en su página web.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  7. Autorizaciones generales para el tratamiento de datos
                  personales.{" "}
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea realiza el tratamiento de los datos personales de
                    sus Usuarios en concordancia con lo dispuesto en la Ley 1581
                    de 2012, Ley 1266 de 2008, decretos reglamentarios y todas
                    las normas referentes al tratamiento de datos personales en
                    Colombia. El Usuario tiene derecho a conocer, actualizar y
                    rectificar su información personal en cualquier momento.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea será el Responsable del tratamiento de datos
                    personales y, en tal virtud, podrá recolectar, almacenar,
                    usar, consultar, reportar ante las centrales de riesgo
                    financieras y terceros la información recolectada del
                    Usuario. El tratamiento que efectúe Galilea cumplirá con las
                    siguientes finalidades:
                  </span>
                </div>
                {personals.map((personal) => (
                  <div key={personal} className="pt-4 lg:pt-8">
                    <span className="block">{personal} </span>
                  </div>
                ))}
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  8. Autorización para la consulta y reporte ante centrales de
                  riesgo financieras o a terceros propietarios de bases de datos
                  de información crediticia.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario consiente de manera expresa, previa e informada,
                    que otorga la autorización a Galilea y a sus aliados,
                    filiales, matrices, cesionarios, compradores de cartera,
                    tanto nacionales como extranjeros, para el tratamiento de su
                    información personal de acuerdo a las finalidades
                    establecidas en el numeral anterior. Así mismo, una vez
                    suscribe los documentos del crédito ratifica la autorización
                    brindada y custodiada por parte de Galilea con la aceptación
                    de los términos y condiciones al momento del registro en la
                    plataforma de Galilea.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario manifiesta que actúa de manera libre y
                    voluntaria, autorizando a Galilea en virtud de las
                    obligaciones derivadas de la relaciones contractuales para
                    consultar, reportar, enviar, procesar, solicitar y divulgar
                    a las Centrales de Información Financiera y Crediticia, a
                    los burós de créditos y a cualquier entidad que maneje o
                    administre bases de datos que tengan como fines de
                    información financiera, crediticia, de control, validación
                    de identidad, biometría, comerciales y de consolidación de
                    información, todos los datos personales y económicos,
                    incluyendo la información referente al comportamiento
                    comercial y crediticio del titular.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  9. Derechos del titular.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los derechos del Usuario como titular de los datos son los
                    previstos en la Constitución Política de Colombia, la Ley
                    1266 de 2008 y en la Ley 1581 de 2012, especialmente los
                    siguientes:
                  </span>
                </div>
                {rights.map((right) => (
                  <div key={right} className="pt-4 lg:pt-8">
                    <span className="block">{right} </span>
                  </div>
                ))}
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Manifiesto que la presente autorización me fue solicitada y
                    puesta de presente antes de entregar mis datos y que la
                    suscribo de forma libre y voluntaria una vez leída en su
                    totalidad.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  10. Firma del contrato y documentos del crédito a través de
                  proceso físico (Opcional).
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Tal como se indicó en la parte superior del presente
                    documento, le corresponde al Usuario la obligación de
                    suscribir todos los documentos del crédito. Para la
                    suscripción de estos documentos el Usuario puede optar por
                    el proceso físico o electrónico con la adquisición de la
                    Firma Electrónica.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea, ha dispuesto para el titular que no desee suscribir
                    los documentos a través de la Firma Electrónica, un canal
                    adicional para realizar la firma del crédito mediante el
                    envío de la siguiente documentación a la dirección de
                    correspondencia física Cl 79 No. 11 66 Ed Spaces, Bogotá o a
                    la dirección electrónica ayuda@galilea.co, si los documentos
                    son enviados a la dirección física o electrónica deben estar
                    autenticados por notaria. Los documentos que debe enviar el
                    Usuario son:
                  </span>
                </div>
                {documents.map((document) => (
                  <div key={document} className="pt-4 lg:pt-8">
                    <span className="block">{document} </span>
                  </div>
                ))}
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El titular se obliga a suministrar información veraz,
                    completa, actualizada y comprobable, así mismo, este deberá
                    garantizar que a partir de los datos suministrados no busca
                    inducir al error en los procesos internos, para lo cual,
                    Galilea en procura de la veracidad realizará las
                    rectificaciones respectivas siendo estas últimas de pleno
                    conocimiento del Usuario. No obstante, Galilea se reserva el
                    derecho de aprobación de la solicitud de crédito y los
                    tiempos para su respuesta.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  11. Validación de identificación personal.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea ha desarrollado protocolos de prevención al fraude y
                    falsedad personal buscando proteger la información del
                    Usuario para lo cual ha creado validaciones de seguridad que
                    se describen a continuación:
                  </span>
                </div>
                {kycs.map((kyc) => (
                  <div key={kyc.title} className="pt-4 lg:pt-8">
                    <span className="block">
                      <span className="font-bold">{kyc.title} </span>
                      {kyc.description}
                    </span>
                  </div>
                ))}
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  12. Veracidad de la información suministrada.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Mediante la aceptación de los presentes términos y
                    condiciones y la suscripción del contrato de crédito, el
                    Usuario declara que la información compartida con Galilea es
                    completa, actual y veraz, resultando de su entera
                    responsabilidad cualquier disconformidad entre los datos
                    entregados y la realidad, bajo la premisa que en tal caso
                    podría convertirse en autor de los delitos de estafa,
                    falsedad en documento privado y/o falsedad personal los
                    cuales se encuentran penalizados de acuerdo con lo
                    establecido al respecto por los artículos 246, 289 y 296 del
                    Código Penal Colombiano. Así mismo, el Usuario declara que
                    los recursos solicitados y objeto del contrato serán usados
                    para ﬁnes lícitos y de ninguna manera para la comisión de
                    cualquiera de los actos establecidos como delitos de acuerdo
                    con la misma legislación penal colombiana.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">13. Perjuicios.</span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En adición a las sanciones penales a las que el titular
                    puede verse involucrado por los delitos mencionados en el
                    parágrafo anterior, en caso de no brindar a Galilea
                    información real y veraz, o no actualizarla dentro del
                    transcurso de la vigencia de la relación comercial, se
                    causan perjuicios a Galilea que, para efectos de su tasación
                    inicial y en adición a todos aquellos perjuicios que se
                    establezcan dentro del proceso judicial correspondiente,
                    ascienden valor correspondiente al cien por ciento (100%) de
                    la suma adeudada por cualquier concepto más los impuestos
                    generados por este concepto.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los perjuicios aquí estimados podrán ser cobrados junto con
                    el capital, intereses remuneratorios, intereses de mora y
                    demás gastos, incluidos los de cobranza, que surjan de la
                    obligación bajo el entendido que los perjuicios aquí
                    indicados y los otros cobros señalados no resultan
                    incompatibles al tener surgimiento en dos situaciones
                    perfectamente distinguibles, los unos de la falta de
                    veracidad o actualidad de la información y los otros del
                    contrato celebrado y sus costos conexos.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  14. Transacciones adicionales.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario entiende y acepta que el presente documento se
                    entiende como formulario de vinculación a los servicios de
                    Galilea y que cada vez que haya una modificación en el monto
                    o plazo del crédito, o demás aspectos del presente acuerdo,
                    las modificaciones, adiciones o supresión de información,
                    serán comunicadas de manera previa al Usuario y se
                    entenderán aceptadas con la utilización de cualquiera de
                    nuestros servicios, a partir de la fecha de entrada en
                    vigor.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    No obstante, las modificaciones que se realicen, por los
                    servicios y montos de crédito suscritos con anterioridad se
                    mantendrán las condiciones establecidas al momento de su
                    aprobación. La aceptación de manera voluntaria e inequívoca
                    de los presentes Términos y Condiciones, al presionar el
                    botón “acepto” el Usuario confirma haber leído y estar de
                    acuerdo con los mismos, lo cual le permite continuar con la
                    solicitud del crédito correspondiente, constituyéndose de
                    esta manera la aceptación clara y expresa al tratamiento de
                    la información personal y las reglas de operación de
                    Galilea, de acuerdo con lo establecido.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  15. Medios de contacto SAC, cobranza y PQRS.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario, podrá ejercer su derecho de información respecto
                    al crédito a su cargo y a interponer peticiones, quejas y
                    reclamos por las condiciones que considere necesarias y
                    pertinentes, en los siguientes canales:
                  </span>
                </div>
                {contacts.map((contact) => (
                  <div key={contact} className="pt-4 lg:pt-8">
                    <div className="block">{contact.title} </div>
                    <div className="block font-bold">{contact.value} </div>
                  </div>
                ))}
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea se compromete a efectuar la debida comunicación a
                    los titulares de la información, cualquier modificación,
                    adición o supresión de los presentes términos y condiciones
                    y la fecha de entrada en vigor.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  16. Legislación aplicable.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los presentes términos y condiciones se aceptan en la Ciudad
                    de Bogotá D.C., la legislación aplicable a la interpretación
                    de los mismos es la Colombiana.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">17. Vigencia.</span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los presentes términos y condiciones entran en vigor a
                    partir del 15 de agosto de 2024. La presente versión
                    corresponde a la número 2.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
